import React, { useCallback } from 'react';
import head from 'lodash/head';
import size from 'lodash/size';

import {
  ChangeProductsFiltersFunc,
  FetchProductsFilterFields
} from '../../../../../../../../products/productsTypes';

import { Translate } from '../../../../../../../../../helpers/Translate';
import { PureIconButtonHelper } from '../../../../../../../../../helpers/buttons/PureIconButtonHelper';
import { IconsEnum } from '../../../../../../../../../assets/icons/types';

import { categoriesKeys } from '../../../../../../../../../locales/keys';

const filterTitles = {
  [FetchProductsFilterFields.AI_FEATURE_TAGS]: categoriesKeys.feature,
  [FetchProductsFilterFields.AI_INTERIOR_STYLE_TAGS]:
    categoriesKeys.styles.singular,
  [FetchProductsFilterFields.AI_MATERIAL_TAGS]:
    categoriesKeys.materials.singular,
  [FetchProductsFilterFields.AI_ROOM_CLASSIFICATION_TAGS]: categoriesKeys.room,
  [FetchProductsFilterFields.AI_MAIN_COLOR_TAGS]: categoriesKeys.colors.plural
};

interface AppliedFilterBadgeProps {
  fieldName: FetchProductsFilterFields;
  changeProductsFilters: ChangeProductsFiltersFunc;
  value: string[];
}

function AppliedFilterBadge({
  changeProductsFilters,
  fieldName,
  value
}: AppliedFilterBadgeProps) {
  const handleRemoveFilter = useCallback(() => {
    changeProductsFilters({}, [fieldName]);
  }, [changeProductsFilters, fieldName]);

  const valueCount = size(value);

  return (
    <div className="relative bg-blue-500 bg-opacity-20 dark:text-gray-200 inline-flex items-center m-0.5 px-3 py-1.5 rounded-md text-gray-800 text-sm ">
      <div>
        <Translate id={filterTitles[fieldName]} />: &nbsp;
        {valueCount > 1 ||
        fieldName === FetchProductsFilterFields.AI_MAIN_COLOR_TAGS
          ? valueCount
          : head(value)}
      </div>

      <PureIconButtonHelper
        className="flex-shrink-0 ml-1 -my-1 -mr-2 h-6 w-6 rounded inline-flex items-center justify-center text-gray-800 dark:text-gray-200 hover:bg-gray-500 hover:bg-opacity-20 hover:text-gray-700 dark:hover:bg-opacity-20 dark:hover:bg-white dark:hover:text-white"
        dataGa={`${fieldName}-clear`}
        icon={IconsEnum.X}
        iconClassName="h-3.5 w-3.5"
        onClick={handleRemoveFilter}
      />
    </div>
  );
}

export default AppliedFilterBadge;
